import { defineMessages } from 'react-intl';

const messages = defineMessages({
  headerText: {
    id: 'X+94C1',
    defaultMessage:
      'Improve your customer experience while driving value for employees,  customers and your business. Take just a minute to fill out the ROI  estimator below and see for yourself how your telco can drive ROI across  customer service by partnering with IBM’s watsonx Assistant.',
  },
  input3: {
    id: 'rF/KOU',
    defaultMessage: 'Total number of HR requests per day',
  },
  input2: {
    id: 'vo+0YZ',
    defaultMessage: 'Number of hours HR spends per day  on repetitive tasks',
  },
  input1: {
    id: 'nCl/ms',
    defaultMessage: 'Number of human resources (HR) employees',
  },
  title1: {
    id: 're0v3I',
    defaultMessage: 'Input the following values for your organization',
  },
  upBar1: {
    id: 'Kf7pMB',
    defaultMessage: '1. Reduce the volume of requests (%)',
  },
  title2: {
    id: '6uNQ4I',
    defaultMessage: 'Adjust the sliders based on your specific goals',
  },
  upBar2: {
    id: 'dNeIna',
    defaultMessage: '2. Improve HR employee productivity (%)',
  },
  resultsText: {
    id: '2L7C8e',
    defaultMessage:
      'Potential productivity benefits that can be reinvested in your business to drive strategic initiatives and focus HR professionals on high value work.',
  },
  bar1: {
    id: 'ibQR+L',
    defaultMessage: 'Reduce the volume of requests',
  },
  bar2: {
    id: 'jSBpjP',
    defaultMessage: 'Improve HR employee productivity',
  },
  resultsTitle: {
    id: 'AIvchG',
    defaultMessage: 'Estimated benefits summary',
  },
  reduce3: {
    id: 'xDd7pI',
    defaultMessage: 'Productivity improvement',
  },
  reduce2: {
    id: 'xKS1HX',
    defaultMessage: 'Savings from fewer ad-hoc HR requests raised',
  },
  savings: {
    id: 'u5jX67',
    defaultMessage: 'Estimate of total annual benefit',
  },
  reduce1: {
    id: 'nSvvxP',
    defaultMessage: 'Savings with self-serviced queries',
  },
  headerTitle: {
    id: '/HIPvJ',
    defaultMessage: 'Estimate your benefits',
  },
});

export default messages;
